// ABOUTME: Hook to read CPQ settings (hierarchy IDs) from the SettingsContext.
// ABOUTME: Provides typed access to CPQ configuration for UI components.

import { CpqSettings } from '@src/__generated__/types';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext, useMemo } from 'react';

/**
 * Reads CPQ settings from the SettingsContext.
 * Returns null if CPQ is not initialized.
 */
export function useCpqSettings(): CpqSettings | null {
    const settings = useContext(SettingsContext);

    return useMemo(() => {
        const cpq = settings?.cpq;
        if (!cpq?.enable) return null;

        return cpq;
    }, [settings]);
}

/**
 * Returns whether the CPQ cart feature is enabled.
 */
export function useIsCartEnabled(): boolean {
    const cpqSettings = useCpqSettings();
    return cpqSettings?.enableCart ?? false;
}
